import React, { useEffect } from "react";

const useEventHandler = () => {
	const [isItemSelectionOpen, setIsItemSelectionOpen] = React.useState(false);

	const observer: MutationObserver = new MutationObserver((event) => {
		let isOpen = false;
		for (let index = 0; index < event.length; index++) {
			const element = event[index];
			if (
				element.type === "attributes" &&
				(element.target as any).classList.contains("show-item-selection")
			) {
				isOpen = true;
				break;
			}
		}
		setIsItemSelectionOpen(isOpen);
	});

	const checkIsItemSelectionOpen = (isMounted = true) => {
		if (!isMounted) {
			observer.disconnect();
			setIsItemSelectionOpen(false);
		}
		if (document.body && isMounted) {
			observer.observe(document.body, {
				attributeFilter: ["class"],
			});
		}
	};

	const keyDownHandler = (event: KeyboardEvent) => {
		event.preventDefault();
		return false;
	};
	const mouseDownHandler = (event: MouseEvent) => {
		event.preventDefault();
		return false;
	};

	// Handle keyboard and mouse events when loading component is rendered
	const handleElSelection = (isLoading: boolean) => {
		if (isLoading) {
			document.addEventListener("keydown", keyDownHandler, true);
			document.addEventListener("mousedown", mouseDownHandler, true);
		} else {
			document.removeEventListener("keydown", keyDownHandler, true);
			document.removeEventListener("mousedown", mouseDownHandler, true);
		}
	};

	useEffect(() => {
		return () => handleElSelection(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		handleElSelection,
		checkIsItemSelectionOpen,
		isItemSelectionOpen,
	};
};

export default useEventHandler;
